export default "__VITE_ASSET__96c6b4a7__"